import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.pos.settings');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-pos-settings',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.pos.settings/view.scss */
:host {
  display: block;
  height: 100%;
}

.sub-screen {
  display: flex;
  flex-direction: column;
  height: 100%;
  background: var(--pos-bg);
  color: var(--pos-text);
  padding: 16px;
  gap: 12px;
}

.sub-header {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 14px;
  background: var(--pos-panel);
  border: 1px solid var(--pos-border);
  border-radius: var(--pos-radius);
  box-shadow: var(--pos-shadow);
}
.sub-header h2 {
  flex: 1;
  margin: 0;
  font-size: 17px;
  font-weight: 800;
}

.back-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 32px;
  background: var(--pos-card);
  border: 1px solid var(--pos-border);
  color: var(--pos-text-dim);
  border-radius: var(--pos-radius-sm);
  cursor: pointer;
}
.back-btn:hover {
  background: var(--pos-hover);
  color: var(--pos-text);
}

.primary-btn, .outline-btn {
  height: var(--pos-control-height);
  padding: 0 16px;
  border-radius: var(--pos-radius-sm);
  font-weight: 800;
  cursor: pointer;
}

.primary-btn {
  border: 1px solid var(--pos-accent);
  background: var(--pos-accent);
  color: #fff;
}

.outline-btn {
  border: 1px solid var(--pos-border);
  background: var(--pos-card);
  color: var(--pos-text);
}

.message-bar {
  padding: 10px 12px;
  border: 1px solid rgba(52, 199, 89, 0.35);
  background: var(--pos-success-bg);
  color: #73d88b;
  border-radius: var(--pos-radius-sm);
  font-size: 13px;
}

.settings-body {
  flex: 1;
  display: grid;
  grid-template-columns: repeat(2, minmax(360px, 1fr));
  gap: 12px;
  overflow: auto;
  min-height: 0;
}

.settings-panel {
  display: flex;
  flex-direction: column;
  gap: 12px;
  min-height: 0;
  background: var(--pos-panel);
  border: 1px solid var(--pos-border);
  border-radius: var(--pos-radius);
  padding: 14px;
  box-shadow: var(--pos-shadow);
}
.settings-panel h3 {
  margin: 0;
  padding-bottom: 10px;
  border-bottom: 1px solid var(--pos-border);
  font-size: 15px;
  font-weight: 800;
}

.form-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;
}

.field {
  display: flex;
  flex-direction: column;
  gap: 6px;
  color: var(--pos-text-dim);
  font-size: 12px;
  font-weight: 800;
}
.field.wide {
  grid-column: 1/-1;
}

input {
  height: var(--pos-field-height);
  border-radius: var(--pos-radius-sm);
  border: 1px solid var(--pos-border);
  background: var(--pos-card);
  color: var(--pos-text);
  padding: 0 10px;
  outline: none;
}
input[readonly] {
  opacity: 0.75;
}

.toggle-field {
  display: flex;
  align-items: center;
  gap: 8px;
  min-height: var(--pos-field-height);
  color: var(--pos-text);
  font-size: 13px;
  font-weight: 700;
}
.toggle-field input {
  width: 18px;
  height: 18px;
  padding: 0;
}

.action-row {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
}

.metric-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 8px;
}

.metric {
  display: flex;
  justify-content: space-between;
  align-items: center;
  min-height: 38px;
  padding: 0 10px;
  border-radius: var(--pos-radius-sm);
  background: var(--pos-card);
  border: 1px solid var(--pos-border);
}
.metric .label {
  color: var(--pos-text-dim);
  font-size: 12px;
  font-weight: 700;
}
.metric .value {
  font-size: 15px;
  font-weight: 800;
}

.role-list {
  display: grid;
  gap: 8px;
}

.role-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  min-height: 38px;
  padding: 0 10px;
  border-radius: var(--pos-radius-sm);
  background: var(--pos-card);
  border: 1px solid var(--pos-border);
}

.role-name {
  font-weight: 800;
}

.role-count {
  color: var(--pos-accent);
  font-weight: 800;
}

.permission-note {
  padding: 10px 12px;
  border-radius: var(--pos-radius-sm);
  background: var(--pos-info-bg);
  color: var(--pos-text-dim);
  font-size: 12px;
}

@media (max-width: 960px) {
  .settings-body {
    grid-template-columns: 1fr;
  }
}`],
})
export class PagePosSettingsComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) {}

    public settings: any = {};
    public roleSummary: any[] = [];
    public counts: any = {};
    public message = '';
    public backupResult: any = null;

    public async ngOnInit() {
        await this.service.init();
        await this.load();
        await this.service.render();
    }

    public async load() {
        const res = await wiz.call('load_settings');
        if (res.code === 200) {
            this.settings = res.data.settings || {};
            this.settings['receipt.autoPrint'] = this.toBool(this.settings['receipt.autoPrint']);
            this.settings['printer.kitchenAuto'] = this.toBool(this.settings['printer.kitchenAuto']);
            this.settings['backup.auto'] = this.toBool(this.settings['backup.auto']);
            this.roleSummary = res.data.roles || [];
            this.counts = res.data.counts || {};
        }
    }

    public goBack() {
        this.service.href('/pos');
    }

    public async save() {
        const payload = { ...this.settings };
        payload['receipt.autoPrint'] = String(Boolean(payload['receipt.autoPrint']));
        payload['printer.kitchenAuto'] = String(Boolean(payload['printer.kitchenAuto']));
        payload['backup.auto'] = String(Boolean(payload['backup.auto']));
        const res = await wiz.call('save_settings', { settings: JSON.stringify(payload) });
        this.message = res.code === 200 ? '환경설정이 저장되었습니다.' : (res.data?.message || '저장에 실패했습니다.');
        if (res.code === 200) {
            await this.load();
        }
        await this.service.render();
    }

    public async backupSnapshot() {
        const res = await wiz.call('backup_snapshot');
        if (res.code === 200) {
            this.backupResult = res.data;
            this.message = `${res.data.backedUpAt} 기준 백업 스냅샷을 만들었습니다.`;
            await this.load();
        } else {
            this.message = res.data?.message || '백업 스냅샷 생성에 실패했습니다.';
        }
        await this.service.render();
    }

    public async testPrinter(type: string) {
        const res = await wiz.call('test_printer', { type });
        if (res.code === 200 && res.data.html) {
            this.printHtml(res.data.html);
            this.message = '테스트 출력을 보냈습니다.';
        } else {
            this.message = res.data?.message || '테스트 출력에 실패했습니다.';
        }
        await this.service.render();
    }

    private printHtml(html: string) {
        const win = window.open('', '_blank', 'width=420,height=640');
        if (!win) return;
        win.document.open();
        win.document.write(html);
        win.document.close();
    }

    private toBool(value: any): boolean {
        return value === true || value === 'true' || value === '1' || value === 1;
    }

    public roleLabel(role: string): string {
        const labels: any = { owner: '대표', manager: '관리자', staff: '직원', admin: '관리자' };
        return labels[role] || role;
    }

    public formatCount(value: any): string {
        return Number(value || 0).toLocaleString();
    }
}

export default PagePosSettingsComponent;